require("./styles/note-list-item-delete.css")

export default (function () {
  class NoteListItemDeleteView extends require("lib/static-shim").default(
    require("lib/core/item-view").default
  ) {
    static initClass() {
      this.prototype.template = require("./templates/note-list-item-delete.html")
      this.prototype.className = "note-list-item-delete-view"

      this.prototype.triggers = {
        "click .delete-note": "delete:note",
        "click .cancel-delete-note": "cancel:delete:note"
      }
    }

    onDeleteNote() {
      this.model.destroy().then(() => {
        return window.App.getStore("note").action.removeNote(this.model)
      })
      return this.destroy()
    }

    onCancelDeleteNote() {
      return this.destroy()
    }
  }
  NoteListItemDeleteView.initClass()
  return NoteListItemDeleteView
})()
